import type { PropsOf } from "@builder.io/qwik";
import { component$, Slot } from "@builder.io/qwik";
import type { FunctionComponent } from "@builder.io/qwik/jsx-runtime";

export const PolymorphicElement = component$(
    <C extends string | FunctionComponent = "div">({
        as,
        ...props
    }: { as?: C } & PropsOf<string extends C ? "div" : C>) => {
        const Cmp = as || "div";
        return (
            <Cmp {...props}>
                <Slot />
            </Cmp>
        );
    },
);
